import { firebase } from '@firebase/app';
import '@firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBXdGWhRQdD-heIHG40i5Uj4WR7iPbBjsc',
  authDomain: 'qgirc0.firebaseapp.com',
  databaseURL: 'https://qgirc0.firebaseio.com',
  projectId: 'qgirc0',
  storageBucket: 'qgirc0.appspot.com',
  messagingSenderId: '721105173957',
  appId: '1:721105173957:web:34fc26a86475da2c1bdfac',
  measurementId: 'G-04XG5VM2KJ',
});

export const db = firebaseApp.firestore();
